import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ModelService } from '../../../../core/services/model/model.service';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { AuthStateService } from '../../../../core/services/auth-state/auth-state-service.service';
import config from './argumentario';
import { copyToClipboard as copyToClipboardUtil } from '../../../../core/utils/clipboard.utils';
@Component({
  selector: 'app-telemarketing-form',
  standalone: true,
  imports: [ReactiveFormsModule, TranslateModule, MatDatepickerModule, MatFormFieldModule, MatInputModule,
    NgSelectModule, CommonModule, FormsModule],
  templateUrl: './telemarketing-form.component.html',
  styleUrl: './telemarketing-form.component.css'
})
export class TelemarketingFormComponent implements OnInit, OnChanges {
  @Input() orderData: any;
  @Input() ladata: any;
  @Output() emitSubmit = new EventEmitter<string>();
  @Output() emitOpenMailPanel = new EventEmitter<{ reference: string; email: string; name: string }>();

  telemarketingForm: FormGroup;
  telemarketingData: any = null;
  isLoading: boolean = false;

  showTimePicker: boolean = false;
  selectedDate: Date | null = null;
  selectedHour: number = 0;
  selectedMinute: number = 0;
  selectedDateTime: Date | null = null;

  hours: number[] = Array.from({ length: 24 }, (_, i) => i);
  minutes: number[] = [0, 15, 30, 45];

  dateControl = new FormControl('');
  timeControl = new FormControl('');

  selectedOption: string = '';
  explanatoryText: string = '';
  idArgumentaryLoaded: boolean = false;

  constructor(
    private fb: FormBuilder,
    private ordersService: OrdersService,
    private alertService: AlertService,
  ) {
    this.telemarketingForm = this.fb.group({
      telemarketing_status: [null],
      telemarketing_action_status: [null],
      telemarketing_action_date: [null, Validators.required],
      telemarketing_notes: [null, Validators.required],
      vin2: [null],
      license_plate2: [null]
    });
  }

  ngOnInit() {
    this.loadTelemarketingData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes['orderData'] && this.orderData) {
        this.refrescarFormulario();
      }
    }


  }

  refrescarFormulario() {
    this.updateFieldAccessibility();
    if (this.orderData) {
      this.telemarketingForm.patchValue({
        telemarketing_status: this.orderData.telemarketing_status || null,
        telemarketing_action_status: this.orderData.telemarketing_action_status || null,
        telemarketing_action_date: this.orderData.telemarketing_action_date || null,
        telemarketing_notes: this.orderData.telemarketing_notes || null,
        vin2: this.orderData.vin || null,
        license_plate2: this.orderData.license_plate || null
      });
      this.explanatoryText =  this.telemarketingData?.telemarketing_statuses.find((status:any) => status.key === this.orderData.telemarketing_status)?.script || 'Texto no disponible';
      this.idArgumentaryLoaded = true;
      if (this.orderData && this.orderData.telemarketing_action_date) {
        try {
          const date = new Date(this.orderData.telemarketing_action_date);
          if (!isNaN(date.getTime())) {
            this.selectedDate = new Date(
              date.getFullYear(),
              date.getMonth(),
              date.getDate()
            );
            this.selectedHour = date.getHours();
            this.selectedMinute = date.getMinutes();
          }
        } catch (error) {
          console.error('Error parsing date:', error);
        }
      }
    }
  }

  clearDateTime() {
    this.telemarketingForm.patchValue({
      telemarketing_action_date: ''
    });
  }

  setToNow() {
    this.telemarketingForm.patchValue({
      telemarketing_action_date: new Date().toISOString()
    });
  }
  onSelectChange(value: any) {
    this.selectedOption = value;
    this.explanatoryText = this.telemarketingData?.telemarketing_statuses.find((status:any) => status.key === value)?.script || 'Texto no disponible';
  }

  showPopout() {

    // Usando SweetAlert2 para mostrar un popout con el texto explicativo
    this.alertService.argumentario(this.explanatoryText);
  }
  updateFieldAccessibility() {
    var rules = { ... this.orderData?.rules, notes_visibility: 'w' };

    for (const field in this.telemarketingForm.controls) {
      if (this.telemarketingForm.controls.hasOwnProperty(field)) {
        this.telemarketingForm.get(field)?.disable();
      }
    }

    for (const field in rules) {
      if (rules.hasOwnProperty(field) && rules[field] === 'w') {
        this.telemarketingForm.get(field)?.enable();
      }
    }
  }

  procesarLadata() {
    if (this.ladata) {
    }
  }

  loadTelemarketingData() {
    this.isLoading = true;
    this.ordersService.getTelemarketingStatusData().subscribe({
      next: (response: any) => {
        if (response.success) {
          this.telemarketingData = response.data;
          if (this.orderData) {
            this.refrescarFormulario();
          }
        } else {
          /*  this.alertService.error('Error al cargar los datos de telemarketing'); */
        }
        this.isLoading = false;
      },
      error: (error: any) => {
        console.error('Error:', error);
        /* this.alertService.error('Error al cargar los datos de telemarketing'); */
        this.isLoading = false;
      }
    });
  }

  checkUpdateForm(): boolean {
    if (this.telemarketingForm.dirty) {
      return true;
    } else {
      return false;
    }
  }

  onDateSelected(event: any) {
    if (event.value) {
      const momentDate = event.value;
      this.selectedDate = new Date(
        momentDate.year(),
        momentDate.month(),
        momentDate.date()
      );
      this.showTimePicker = true;
      this.initializeTime();
    } else {
      this.selectedDate = null;
      this.showTimePicker = false;
    }
  }

  getFormattedDate(): string {
    if (!this.selectedDate) return '';

    const day = this.selectedDate.getDate().toString().padStart(2, '0');
    const month = (this.selectedDate.getMonth() + 1).toString().padStart(2, '0');
    const year = this.selectedDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  confirmTimeSelection() {
    if (this.selectedDate) {
      const finalDateTime = new Date(
        this.selectedDate.getFullYear(),
        this.selectedDate.getMonth(),
        this.selectedDate.getDate(),
        this.selectedHour,
        this.selectedMinute,
        0
      );
      const year = finalDateTime.getFullYear();
      const month = String(finalDateTime.getMonth() + 1).padStart(2, '0');
      const day = String(finalDateTime.getDate()).padStart(2, '0');
      const dateString = `${year}-${month}-${day}`;

      this.telemarketingForm.patchValue({
        telemarketing_action_date: dateString + " " + this.selectedHour + ":" + this.selectedMinute + ":00",

      });

      this.selectedDate = finalDateTime;
    }

    this.showTimePicker = false;
  }

  selectHour(hour: number) {
    this.selectedHour = hour;
  }
  selectMinute(minute: number) {
    this.selectedMinute = minute;
  }

  clearSelection() {
    this.selectedDate = null;
    this.initializeTime();
    this.telemarketingForm.patchValue({
      telemarketing_action_date: ''
    });
    this.showTimePicker = false;
  }

  initializeTime() {
    const now = new Date();
    this.selectedHour = now.getHours();
    this.selectedMinute = Math.floor(now.getMinutes() / 15) * 15;
  }

  copyToClipboard(value: string, event: Event): void {
    copyToClipboardUtil(value, event);
  }

  // ============ MAIL MODAL ============

  openMailModal(clientReference: string): void {
    this.emitOpenMailPanel.emit({
      reference: clientReference,
      email: this.orderData?.client?.email || '',
      name: this.orderData?.client?.name || '',
    });
  }

}
